export enum TemplateTypes {
    CustomerService = 0,
    System = 1,
    TechSupport = 2,
    Training = 3,
    Transaction = 4,
    AccountManagement = 5,
    Unknown = 99
}

export interface IEmailTemplateItem {
    ID: number;
    Name: string;
    Description: string;
    TemplateType: TemplateTypes;
    IsAutomated: boolean;
}

export class EmailTemplateItemArray extends Array<IEmailTemplateItem> {
    constructor(...items: EmailTemplateItem[]) {
        super(...items);
        Object.setPrototypeOf(this, EmailTemplateItemArray.prototype);
    }
}

export class EmailTemplateItem implements IEmailTemplateItem {
    ID: number;
    Name: string;
    Description: string;
    TemplateType: TemplateTypes;
    IsAutomated: boolean;
}
